import React from 'react'
import ui from 'redux-ui'
import { FormField } from "semantic-ui-react";
import { Button, Form, Header, Icon } from 'semantic-ui-react'
import { Modal } from 'semantic-ui-react-with-store'
import RichTextEditor from "../../forms/richText/RichTextEditor";

class BilanForm extends React.Component {

  bilanFields = [ 'symptoms', 'aid_request', 'plan', 'conclusion']

  initialState = () => {
    return Object.fromEntries(this.bilanFields.map(field => [field, '']))
  }

  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  handleSubmit = () => {
    this.props.onSubmit(this.state)
    this.setState(this.initialState())
    this.props.updateUI('open', false)
  }

  render() {
    return (
      <Modal
      trigger={this.props.trigger} closeIcon
      open={this.props.ui.open}
      onClose={() => this.props.updateUI('open', false)}
      onOpen={() => this.props.updateUI('open', true)}
      >
        <Header content={I18n.t('components.dossier.documents.bilan.title')} />
        <Modal.Content>
          <Form>
            {this.renderFormFields()}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color='green'
          onClick={() => this.handleSubmit()}>
            <Icon name='file pdf outline' /> {I18n.t('generic.create')}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

  renderFormFields() {
    return this.bilanFields.map(
      field => {
       return(
        <FormField key={`bilan_form_${field}`}>
          <label>{I18n.t(`components.dossier.documents.bilan.${field}`)}</label>
          <RichTextEditor serializeToHtml={true} key={field} simplified
                          onChange={(value) => this.setState({[field]: value})}
          />
        </FormField>
      )
      }
    )
  }
}

export default ui({state: { open: false}})(BilanForm);
